import { SimpleBars } from '../../../Common/Charts/SimpleBars';

import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const SizeEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    const sizeMap = {
        '1': 'Pequeno I',
        '2': 'Pequeno II',
        '3': 'Médio',
        '4': 'Grande', 'Grande Porte': 'Grande',
    };

    const groupedData = chartData.size.reduce((acc, item) => {
        const normalizedSize =
            sizeMap[item.porte] ||
            item.porte ||
            'Não informado';

        if (!acc[normalizedSize]) {
            acc[normalizedSize] = 0;
        }

        acc[normalizedSize] += 1;

        return acc;
    }, {});

    return (
        <SimpleBars
            title="Distribuição dos Portes"
            horizontal={true}
            subtitles={Object.keys(groupedData)}
            values={Object.values(groupedData)}
        />
    );
};